/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createTanh } from '../../factoriesAny.js';
export var tanhDependencies = {
  typedDependencies,
  createTanh
};